import { ReactNode } from 'react';

import { cls } from '@/utils/cls';

type Props = {
  onClick: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
};

export function FiltersButton({ onClick, children, className, disabled, type = 'button' }: Props) {
  const baseClass =
    'inline-flex items-center gap-2 rounded-md border border-[#274483]/20 bg-[#274483]/5 px-3 py-1.5 text-sm font-semibold text-[#274483] hover:bg-[#274483]/10 cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-[#274483]/5';

  return (
    <button type={type} className={cls(baseClass, className)} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
